import { useState } from "react";
import { Link } from "react-router-dom";
import { ABOUT_US_URL, BLOGS_URL, FEES_URL, GETTING_STARTED_URL, route } from "../../routes";
import { AccordionSection } from "../Accordion";
import { FooterMenuItem } from "./GoodfillFooter";
import "./GoodFillFooter.scss";

const GOODFILL_URL = import.meta.env.VITE_GOODFILL_URL;

export const CompanyAccordion = () => {
  const [isCompanyAccordionOpen, setCompanyAccordionOpen] = useState(true);

  return (
    <AccordionSection
      title={"Company"}
      isOpen={isCompanyAccordionOpen}
      setIsOpen={setCompanyAccordionOpen}
      className="GoodFillFooter_accordion"
    >
      <ul>
        <FooterMenuItem title="GoodFill" href={GOODFILL_URL} current>
          GoodFill
        </FooterMenuItem>
        <FooterMenuItem title="About Us" href={ABOUT_US_URL}>
          About Us
        </FooterMenuItem>
        <FooterMenuItem title="Getting Started" href={GETTING_STARTED_URL}>
          Getting Started
        </FooterMenuItem>
        <FooterMenuItem title="Fees" href={FEES_URL}>
          Fees
        </FooterMenuItem>
        <Link to={route.dashboard()} target="_blank">
          <FooterMenuItem title="Bonds">Bonds</FooterMenuItem>
        </Link>
        <FooterMenuItem title="Blog" href={BLOGS_URL}>
          Blog
        </FooterMenuItem>
      </ul>
    </AccordionSection>
  );
};
